export default __webpack_public_path__ + "static/media/GenerateFeedbackPreview.c8269b53.mp4";